




































































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import {
  CustomerEditModel,
  ProjectAsCustomerEditModel,
  ProjectStaffAppUserViewModel,
  ProjectStaffEditModel,
  RateRuleAmountFilter,
} from '@/services/api/nswag/stapiclient_generated';
import { projectStaffApi, stCustomerApi, stProjectApi } from '@/services/st-api';
import { UserStore } from '@/store/user-module';
import StRatePicker from '@/components/basic/StRatePicker.vue';
import SlideIn from '@/components/basic/SlideIn.vue';
import StInput2 from '@/components/basic/StInput2.vue';
import StToggle from '@/components/basic/StToggle.vue';
import StTextarea from '@/components/basic/StTextarea.vue';
import { notifySuccess } from '@/utlitities/notifications';
import { TabModel } from '@/components/tabs/tab-model';
import StTabs from '@/components/tabs/StTabs.vue';
import EditCustomerTextOverwriter from '@/views/Projects/EditCustomerTextOverwriter.vue';
import ProjectStaffEdit from '@/views/Projects/ProjectStaffEdit.vue';
import StPercentInput from '@/components/basic/StPercentInput.vue';
import StDatePicker from '@/components/basic/StDatePicker.vue';
import StCurrencyInput from '@/components/basic/StCurrencyInput.vue';
import ProjectChangeFixedPriceWarning from '@/views/Projects/ProjectChangeFixedPriceWarning.vue';
import EditCustomerProject from '@/views/Projects/EditCustomerProject.vue';

@Component({
  components: {
    EditCustomerProject,
    ProjectChangeFixedPriceWarning,
    StCurrencyInput,
    StDatePicker,
    StTextarea,
    StToggle,
    StInput2,
    SlideIn,
    StRatePicker,
    StTabs,
    EditCustomerTextOverwriter,
    ProjectStaffEdit,
    StPercentInput,
  },
})
export default class EditCustomer extends Vue {
  private id: number = 0;
  private customer: CustomerEditModel = CustomerEditModel.fromJS({ name: '' });
  private loading: boolean = true;
  private delayLoading: boolean = false;
  private saving: boolean = false;
  private listPage: string = 'Projects';
  noOfActiveProjects: number = 0;
  appUsers: ProjectStaffAppUserViewModel[] = [];
  isReadonly = false;

  openSlideIn() {
    (this.$refs.slideIn as SlideIn).open();
  }

  closeSlideIn() {
    (this.$refs.slideIn as SlideIn).close();
  }

  slideOutClosed() {
    if (this.$router.currentRoute.meta.activeGroup == 'postprocess') {
      this.$router.push({ name: 'OutgoingInvoiceEdit', params: this.$router.currentRoute.params });
    } else {
      this.$router.push({ name: this.listPage });
    }
  }

  created() {
    if (this.$router.currentRoute.meta.activeGroup == 'postprocess') {
      this.id = parseInt(this.$route.params.customerId);
      this.activeTabName = 'invoice';
    } else {
      this.id = parseInt(this.$route.params.id);
    }
    this.isReadonly = !!this.$route.params.readonly;
  }

  get countries(): any[] {
    const countries = [
      {
        value: 'DE',
        description: 'Deutschland',
      },
      {
        value: 'AT',
        description: 'Österreich',
      },
      {
        value: 'CH',
        description: 'Schweiz',
      }
      ,
      {
        value: 'NL',
        description: 'Niederlande',
      }
      ,
      {
        value: 'BE',
        description: 'Belgien',
      }
      ,
      {
        value: 'FR',
        description: 'Frankreich',
      }
      ,
      {
        value: 'DK',
        description: 'Dänemark',
      }
    ];
    return countries;
  }

  get fromInvoice() {
    return this.$router.currentRoute.meta.activeGroup == 'postprocess';
  }

  get useFixedPriceProjects() {
    return UserStore.userSettings.useFixedPriceProjects;
  }

  get useEInvoice(): boolean {
    return UserStore.userSettings.useEInvoice;
  }

  activeTabName = 'standard';

  get tabs(): TabModel[] {
    let res = [
      {
        TabName: 'standard',
        Disabled: this.fromInvoice,
      },
    ];

    if (this.useInvoice) {
      res.push({
        TabName: 'invoice',
        Disabled: false,
      });
    }

    if (this.customer.hasNoProjects && this.appUsers.length) {
      res.push({
        TabName: 'rights',
        Disabled: false,
      });
    }

    return res;
  }

  async mounted() {
    this.openSlideIn();

    await this.loadEditModel();
    if (this.id) {
      this.noOfActiveProjects = await stCustomerApi.getNoOfActiveProjects(this.id);
    }

    if (this.customer.hasNoProjects) {
      this.appUsers = await projectStaffApi.getEmployees(this.project.id ?? 0);
    }

    this.loading = false;
  }

  async loadEditModel() {
    this.customer = this.id == 0 ? await stCustomerApi.getNew() : await stCustomerApi.get(this.id);
  }

  async hasNoProjectChanged() {
    try {
      this.delayLoading = true;
      if (this.customer.hasNoProjects) {
        this.customer.projectEditModel = await stProjectApi.getProjectAsCustomerEditModel(this.id);
        this.appUsers = await projectStaffApi.getEmployees(this.project.id ?? 0);
      }
    } finally {
      this.delayLoading = false;
    }
  }

  get budgetUnitOptions() {
    return [
      { id: 'Currency', description: UserStore.userSettings.currency, disabled: UserStore.userSettings.noRates },
      { id: 'Hours', description: 'Stunden (alle)' },
      { id: 'HoursBillable', description: 'Stunden (verrechenbar)' },
    ];
  }

  setThresholdIfZero() {
    if (this.project.notifyOnBudgetOverrun && this.project.budgetOverrunThresholdPercent == 0) {
      this.project.budgetOverrunThresholdPercent = 100;
    }
  }

  get project() {
    return this.customer.projectEditModel ?? ProjectAsCustomerEditModel.fromJS({});
  }

  set project(data: ProjectAsCustomerEditModel) {
    this.customer.projectEditModel = data;
  }

  get projectStaffEditModels() {
    return this.project.projectStaff ?? [];
  }

  get canViewRates() {
    return UserStore.userSettings.CanViewRates && !UserStore.userSettings.noRates;
  }

  get rateRuleAmountFilter() {
    return RateRuleAmountFilter.fromJS({
      customerId: this.id,
      projectId: undefined,
      projectTaskId: undefined,
      appUserId: undefined,
    });
  }

  @Watch('customer.amountModel.overrideAmount')
  overrideChanged() {
    if (this.customer?.amountModel && !this.customer.amountModel.overrideAmount) {
      this.customer.amountModel!.amount = this.customer.amountModel?.parentAmount ?? 0;
    }
  }

  get useRateRules() {
    return UserStore.userSettings.useRateRules;
  }

  get useInvoice() {
    return !UserStore.userSettings.noOutgoingInvoices;
  }

  get useInvoiceEmailSending() {
    return UserStore.userSettings.useInvoiceEmailSending;
  }

  get currency() {
    return UserStore.userSettings.currency;
  }

  async submit() {
    try {
      this.saving = true;
      if (this.customer.id == 0) {
        await stCustomerApi.post(this.customer);
      } else {
        await stCustomerApi.put(this.customer.id, this.customer);
      }

      notifySuccess('Erfolgreich gespeichert');
      this.closeSlideIn();
    } finally {
      this.saving = false;
    }
  }
}
